import { MessageService } from '../../../services/messages.service';
import { SnackBarService } from '../../../services/snackbar.service';
import { WarmUpService } from '../../../services/warmup/warmup.service';
import { TrackingService } from '../../../shared/services/tracking/google-analytics-events.service';
import { TrackingConstants } from './../../../shared/services/tracking/tracking-constants.service';
import { SurveyManagementService } from './../survey-management.service';
import { SurveyQuestion } from '../../../shared/models/survey/survey-question.model';
import { SurveyTemplate } from '../../../shared/models/survey/survey-template.model';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MdDialogRef } from '@angular/material';


@Component({
  selector: 'add-surveytemplate',
  templateUrl: './add-surveytemplate.component.html',
  styleUrls: ['./add-surveytemplate.component.css']
})

/**
 * Component to add new survey template.
 *
 * @author mohit.khurana@vernuso.com (Mohit Khurana)
 */
export class AddSurveyTemplateComponent implements OnInit {
  selectedTemplate: SurveyTemplate;
  action: string;
  createSurveyTemplateForm: FormGroup;
  templateId = -1;
  templateQuestions: SurveyQuestion[];
  actionType: string;

  formErrors = {
    'surveyTitle': '',
    'surveyDescription': ''
  };

  validationMessages = {
    'surveyTitle': {
      'required': 'Required field value.',
    },
    'surveyDescription': {
      'required': 'Required field value.',
    }
  };

  constructor(
    private formBuilder: FormBuilder,
    public dialogRef: MdDialogRef<any>,
    private surveyManagementRestService: SurveyManagementService,
    private warmUpService: WarmUpService,
    private snackBarService: SnackBarService,
    private cdr: ChangeDetectorRef,
    private trackingService: TrackingService) { }

  ngOnInit(): void {
    this.buildForm();
    this.updateSurveyTemplateForm();
    this.actionType = this.action == 'Add' && 'New' || 'Edit';
  }

  buildForm() {
    this.createSurveyTemplateForm = this.formBuilder.group({
      surveyTitle: ['', Validators.required],
      surveyDescription: ['', Validators.required],
    });

    this.createSurveyTemplateForm.valueChanges.subscribe(
      data => this.onValueChanged(data));
    this.onValueChanged(); // (re)set validation messages now
  }

  onValueChanged(data?: any) {
    if (!this.createSurveyTemplateForm) {
      return;
    }
    const form = this.createSurveyTemplateForm;

    for (const field in this.formErrors) {
      this.formErrors[field] = '';
      const control = form.get(field);
      if (control && control.touched && !control.valid) {
        const messages = this.validationMessages[field];
        for (const key in control.errors) {
          this.formErrors[field] += messages[key] + ' ';
        }
      }
    }
  }

  onSubmit({ value, valid }) {
    const surveyTemplate = new SurveyTemplate();
    surveyTemplate.id = this.templateId;
    surveyTemplate.description = value.surveyDescription;
    surveyTemplate.questions = this.templateQuestions;
    surveyTemplate.title = value.surveyTitle;
    this.surveyManagementRestService.addSurveyTemplate(surveyTemplate)
      .subscribe(response => {
        if (response.flagResult) {
          this.dialogRef.close(response.arrResult);
        }
        this.trackingService
          .emitEvent(
          TrackingConstants.SURVEY_MANAGEMENT,
          TrackingConstants.SAVE_SURVEY_TEMPLATE,
          TrackingConstants.SUCCESS, 1);
        this.callSnackBarService(response, this.action);
      }, err => {
        this.trackingService
          .emitEvent(
          TrackingConstants.SURVEY_MANAGEMENT,
          TrackingConstants.SAVE_SURVEY_TEMPLATE,
          TrackingConstants.FAILURE, 0);
        this.callSnackBarService(err, this.action);
      });
  }

  callSnackBarService(response: any, operation: string) {
    this.snackBarService
      .showStatus(response,
      operation === 'Add'
      && MessageService.ADD_SURVEY_TEMPLATE_SUCCESS
      || MessageService.UPDATE_SURVEY_TEMPLATE_SUCCESS,
      MessageService.SURVEY_TEMPLATE_FAILURE);
  }

  updateSurveyTemplateForm(): void {
    if (this.selectedTemplate) {
      this.templateId = this.selectedTemplate.id;
      this.templateQuestions = this.selectedTemplate.questions;
      this.createSurveyTemplateForm.patchValue({
        surveyTitle: this.selectedTemplate.title,
        surveyDescription: this.selectedTemplate.description,
      });
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/admin/survey/addsurveytemplate/add-surveytemplate.component.ts